import spartaStickyUtility from "utilities/global/sparta-sticky-utility/4.0.4/js/sparta-sticky-utility";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import recalculateStickyUtility from "utilities/community/recalculate-sticky-utility/1.0.1/js/recalculate-sticky-utility";
import spartaTemplates from "modules/global/title-module/9.0.0/js/templates";
import "css!modules/global/title-module/9.0.0/css/title-module.scss.css";
/* global Module */

const mdaVars = {
  paramName: 'wrap',
  paramExpectedValue: 'mda',
  versionParamName: 'mda_app_version',
  expectedVersion: 7.9,
};

/**
  * Class export.
  * @returns {void}
  */
export default class titleModuleJS extends Module {
  /**
   * Initialize the module.
   * @returns {void}
   */
  init() {
    // Check for MDA parameter and version.
    const isMda = this.SpartaFunctions.getUrlParam(mdaVars.paramName)
      || this.Store.getPersisted(mdaVars.paramName);

    // Hardcoded until a param exists, like `mdaVars.versionParamName`.
    const mdaVersion = mdaVars.expectedVersion;

    // Continue MDA check.
    const isDefined = (isMda !== undefined && isMda !== null);
    if (isDefined) {
      const isExpectedValue = (
        isMda.toLowerCase() === mdaVars.paramExpectedValue
        && mdaVersion >= mdaVars.expectedVersion
      );
      if (isExpectedValue) {
        this.Store.persist(mdaVars.paramName, mdaVars.paramExpectedValue);
      }
    }
  }
}
